import { render, staticRenderFns } from "./Er.vue?vue&type=template&id=45d15dde&scoped=true&"
import script from "./Er.vue?vue&type=script&lang=js&"
export * from "./Er.vue?vue&type=script&lang=js&"
import style0 from "./Er.vue?vue&type=style&index=0&id=45d15dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d15dde",
  null
  
)

export default component.exports